module.exports = __webpack_public_path__ + "static/media/ht-logo.93943219.svg";